(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-size-chart-page"] && !Shopify.designMode) return;
  try {
    
  // Simple tab switcher for the standalone page (no dependency on md-smart-collection.js)
  (function () {
    var nav = document.querySelector('[data-md-chart-page-tabs]');
    if (!nav) return;
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tab]');
      if (!btn) return;
      var target = btn.getAttribute('data-tab');
      var root = nav.parentElement;
      root.querySelectorAll('[data-tab]').forEach(function (t) {
        var on = t.getAttribute('data-tab') === target;
        t.setAttribute('aria-selected', String(on));
        t.classList.toggle('md-chart-page__tab--active', on);
      });
      root.querySelectorAll('[data-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== target;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-smart-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-md9-section]');
  if (!section) return;
  section.classList.add('md9--js');
  var sectionId = section.getAttribute('data-section-id');
  var collectionUrl = section.getAttribute('data-md9-collection-url') || window.location.pathname;

  var loadMoreObserver = null;
  var loadMoreInFlight = false;

  function getSentinel() { return section.querySelector('[data-md9-load-more]'); }

  function setupLoadMore() {
    var sentinel = getSentinel();
    if (!sentinel || !('IntersectionObserver' in window)) return;
    if (loadMoreObserver) loadMoreObserver.disconnect();
    loadMoreObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !loadMoreInFlight) {
          loadNextPage(entry.target);
        }
      });
    }, { rootMargin: '400px 0px' });
    loadMoreObserver.observe(sentinel);
  }

  async function loadNextPage(sentinel) {
    if (loadMoreInFlight) return;
    var nextUrl = sentinel.getAttribute('data-md9-next-url');
    if (!nextUrl) return;
    loadMoreInFlight = true;

    try {
      var sep = nextUrl.indexOf('?') >= 0 ? '&' : '?';
      var url = nextUrl + sep + 'section_id=' + sectionId + '&_=' + Date.now();
      var res = await fetch(url, { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var newGrids = doc.querySelectorAll('[data-md9-results] .md9-grid');
      var curGrids = section.querySelectorAll('[data-md9-results] .md9-grid');
      newGrids.forEach(function (newGrid, idx) {
        var sectionTag = newGrid.getAttribute('data-md9-grid-section');
        var target = null;
        if (sectionTag) {
          target = section.querySelector('[data-md9-results] .md9-grid[data-md9-grid-section="' + sectionTag + '"]');
        }
        if (!target) {
          target = curGrids[idx] || curGrids[curGrids.length - 1];
        }
        if (!target) return;
        var addedCount = 0;
        Array.from(newGrid.children).forEach(function (item) {
          target.appendChild(item);
          addedCount++;
        });
        
        applySizeSortOrder(target);
        
        updateDiscountCounts();
        applyDiscountFilter();
        
        if (sectionTag && addedCount > 0) {
          var countEl = section.querySelector('[data-md9-section-count="' + sectionTag + '"]');
          if (countEl) {
            var totalItems = target.children.length;
            countEl.textContent = '(' + totalItems + ')';
          }
        }
      });

      var newSentinel = doc.querySelector('[data-md9-load-more]');
      var newFallback = doc.querySelector('[data-md9-paginate-fallback]');
      if (loadMoreObserver) loadMoreObserver.unobserve(sentinel);

      if (newSentinel) {
        
        sentinel.replaceWith(newSentinel);
        
        var curFallback = section.querySelector('[data-md9-paginate-fallback]');
        if (curFallback && newFallback) curFallback.replaceWith(newFallback);
        
        setupLoadMore();
      } else {
        
        sentinel.remove();
        var fb = section.querySelector('[data-md9-paginate-fallback]');
        if (fb) fb.remove();
      }
    } catch (err) {
      console.warn('Load more failed:', err);
      
      var sNow = getSentinel();
      if (sNow && loadMoreObserver) loadMoreObserver.observe(sNow);
    } finally {
      loadMoreInFlight = false;
    }
  }

  setupLoadMore();

  var SECONDARY_INITIAL_PAGES = 10; 
  var secondaryUserConfirmedMore = false;

  function fetchSecondaryIfNeeded() {
    var secondaryGrid = section.querySelector('[data-md9-secondary-fetch-value]');
    if (!secondaryGrid) return;
    var secondaryValue = secondaryGrid.getAttribute('data-md9-secondary-fetch-value');
    if (!secondaryValue) return;
    
    secondaryGrid.removeAttribute('data-md9-secondary-fetch-value');
    
    secondaryUserConfirmedMore = false;
    
    var oldBtn = section.querySelector('[data-md9-secondary-load-more-btn]');
    if (oldBtn) oldBtn.remove();
    
    fetchSecondaryPage(secondaryValue, 1, secondaryGrid);
  }

  function fetchSecondaryPage(secondaryValue, page, secondaryGrid) {
    var fetchUrl = collectionUrl
      + '?filter.v.option.gender=' + encodeURIComponent(secondaryValue)
      + '&page=' + page
      + '&section_id=' + sectionId
      + '&_=' + Date.now();

    fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-md9-results] .md9-grid');
        if (!newGrid) return;
        var items = Array.from(newGrid.children);

        if (items.length === 0 && page === 1) {
          
          var hdr = section.querySelector('[data-md9-section-hdr="secondary"]');
          if (hdr) hdr.style.display = 'none';
          secondaryGrid.style.display = 'none';
          return;
        }

        items.forEach(function (item) { secondaryGrid.appendChild(item); });
        applySizeSortOrder(secondaryGrid);
        
        updateDiscountCounts();
        applyDiscountFilter();

        var hasMore = doc.querySelector('[data-md9-load-more]') !== null;
        if (!hasMore) return; 

        if (page < SECONDARY_INITIAL_PAGES || secondaryUserConfirmedMore) {
          
          fetchSecondaryPage(secondaryValue, page + 1, secondaryGrid);
        } else {
          
          showSecondaryLoadMoreButton(secondaryValue, page + 1, secondaryGrid);
        }
      })
      .catch(function (err) {
        console.warn('Secondary fetch failed (page ' + page + '):', err);
      });
  }

  function showSecondaryLoadMoreButton(secondaryValue, nextPage, secondaryGrid) {
    
    var existing = section.querySelector('[data-md9-secondary-load-more-btn]');
    if (existing) existing.remove();

    var btn = document.createElement('button');
    btn.setAttribute('data-md9-secondary-load-more-btn', '');
    btn.className = 'md9-secondary-load-more-btn';
    btn.type = 'button';
    btn.textContent = 'Show more products';

    if (secondaryGrid.parentNode) {
      secondaryGrid.parentNode.insertBefore(btn, secondaryGrid.nextSibling);
    }

    btn.addEventListener('click', function () {
      
      secondaryUserConfirmedMore = true;
      btn.remove();
      fetchSecondaryPage(secondaryValue, nextPage, secondaryGrid);
    });
  }

  fetchSecondaryIfNeeded();

  function applySizeSortOrder(scope) {
    scope = scope || section;

    var url, sortVal;
    try { url = new URL(window.location.href); sortVal = url.searchParams.get('sort_by'); }
    catch (e) { sortVal = null; }
    var sortActive = sortVal && sortVal !== '' && sortVal !== 'manual';

    // Walk each grid's children in DOM order. Break panels (.md9-grid__break)
    // anchor "segment" boundaries; products sort by size-count WITHIN their
    // segment. This keeps the stories/engage breaks pinned to their DOM
    // position instead of floating to order:0 (which caused the glitch).
    var grids = scope.querySelectorAll('.md9-grid');
    if (!grids.length && scope.classList && scope.classList.contains('md9-grid')) {
      grids = [scope];
    }
    grids.forEach(function (grid) {
      var seg = 0;
      Array.prototype.forEach.call(grid.children, function (el) {
        if (el.classList.contains('md9-grid__break')) {
          // break sits at the end of the current segment, before the next
          el.style.order = String(seg * 1000 + 999);
          seg++;
          return;
        }
        if (!el.hasAttribute || !el.hasAttribute('data-md9-size-count')) return;
        if (sortActive) {
          el.style.order = String(seg * 1000);
        } else {
          var c = parseInt(el.getAttribute('data-md9-size-count') || '0', 10);
          if (c > 99) c = 99;
          // within segment, higher size-count → lower order → earlier
          el.style.order = String(seg * 1000 + (100 - c));
        }
      });
    });
  }
  applySizeSortOrder();

  function updateStickyBarActiveStates() {
    var filterBtn = section.querySelector('[data-md9-open-drawer]');
    if (filterBtn) {
      var url, hasFilter = false;
      try { url = new URL(window.location.href); } catch (e) {}
      if (url) {
        url.searchParams.forEach(function (v, k) {
          if (k && k.indexOf('filter.') === 0 && v !== '') hasFilter = true;
        });
      }
      
      if (!hasFilter) {
        var form = section.querySelector('[data-md9-filter-form]');
        if (form) {
          var inputs = form.querySelectorAll('input[name^="filter."]:checked');
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value !== '') { hasFilter = true; break; }
          }
        }
      }
      
      if (!hasFilter) {
        var anyDiscount = section.querySelector('[data-md9-discount-bucket]:checked');
        if (anyDiscount) hasFilter = true;
      }
      filterBtn.classList.toggle('md9-stickybar__btn--has-filter', hasFilter);
    }
  }
  updateStickyBarActiveStates();

  function bucketOf(pct) {
    if (pct <= 0) return null;
    if (pct < 25) return 'under25';
    if (pct < 50) return '25to50';
    if (pct < 75) return '50to75';
    return '75plus';
  }
  function updateDiscountCounts() {
    var counts = { under25: 0, '25to50': 0, '50to75': 0, '75plus': 0 };
    section.querySelectorAll('[data-md9-discount]').forEach(function (item) {
      var pct = parseInt(item.getAttribute('data-md9-discount') || '0', 10);
      var b = bucketOf(pct);
      if (b) counts[b]++;
    });
    section.querySelectorAll('[data-md9-discount-count]').forEach(function (badge) {
      var bk = badge.getAttribute('data-md9-discount-count');
      var n = counts[bk] || 0;
      badge.textContent = n > 0 ? '(' + n + ')' : '';
    });
    section.querySelectorAll('[data-md9-discount-bucket-label]').forEach(function (label) {
      var bk = label.getAttribute('data-md9-discount-bucket-label');
      var n = counts[bk] || 0;
      label.style.display = n > 0 ? '' : 'none';
      
      if (n === 0) {
        var input = label.querySelector('[data-md9-discount-bucket]');
        if (input && input.checked) { input.checked = false; }
      }
    });
    var total = counts.under25 + counts['25to50'] + counts['50to75'] + counts['75plus'];
    section.querySelectorAll('[data-md9-discount-group]').forEach(function (group) {
      group.style.display = total > 0 ? '' : 'none';
    });
  }
  function applyDiscountFilter() {
    var checked = section.querySelectorAll('[data-md9-discount-bucket]:checked');
    if (checked.length === 0) {
      section.querySelectorAll('[data-md9-discount-hidden]').forEach(function (item) {
        item.removeAttribute('data-md9-discount-hidden');
      });
      return;
    }
    var allowed = {};
    checked.forEach(function (i) { allowed[i.getAttribute('data-md9-discount-bucket')] = true; });
    section.querySelectorAll('[data-md9-discount]').forEach(function (item) {
      var pct = parseInt(item.getAttribute('data-md9-discount') || '0', 10);
      var b = bucketOf(pct);
      if (b && allowed[b]) item.removeAttribute('data-md9-discount-hidden');
      else item.setAttribute('data-md9-discount-hidden', '');
    });
  }
  function syncDiscountInputs(source) {
    var bucket = source.getAttribute('data-md9-discount-bucket');
    var checked = source.checked;
    section.querySelectorAll('[data-md9-discount-bucket="' + bucket + '"]').forEach(function (input) {
      if (input !== source) input.checked = checked;
    });
  }

  section.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-md9-discount-bucket]')) {
      e.stopPropagation();
      syncDiscountInputs(e.target);
      applyDiscountFilter();
      updateStickyBarActiveStates();
    }
  }, true);
  updateDiscountCounts();
  applyDiscountFilter();

  function syncQfChips() {
    var qf = section.querySelector('[data-md9-quickfilters]');
    if (!qf) return;
    var form = section.querySelector('[data-md9-filter-form]');
    if (!form) return;
    qf.querySelectorAll('[data-md9-qf]').forEach(function (chip) {
      var kind = chip.getAttribute('data-md9-qf');
      var value = chip.getAttribute('data-md9-value');
      var matched = false;
      if (kind === 'gender') {
        var inputs = form.querySelectorAll('input[name*="gender"]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === value && inputs[i].checked) { matched = true; break; }
        }
      } else if (kind === 'price') {
        var radios = form.querySelectorAll('input[name*="price.lte"]');
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].value === value && radios[j].checked) { matched = true; break; }
        }
      } else if (kind === 'type') {
        var tinputs = form.querySelectorAll('input[name*="product_type"]');
        for (var k = 0; k < tinputs.length; k++) {
          if (tinputs[k].value === value && tinputs[k].checked) { matched = true; break; }
        }
      }
      chip.classList.toggle('md9-qf-chip--on', matched);
    });
  }
  section.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-md9-qf]');
    if (!chip) return;
    e.preventDefault();
    var kind = chip.getAttribute('data-md9-qf');
    var value = chip.getAttribute('data-md9-value');
    var form = section.querySelector('[data-md9-filter-form]');
    if (!form) return;
    if (kind === 'gender') {
      var inputs = form.querySelectorAll('input[name*="gender"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) {
          inputs[i].checked = !inputs[i].checked;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    } else if (kind === 'price') {
      var radios = form.querySelectorAll('input[name*="price.lte"]');
      var target = null;
      var anyRadio = null;
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].value === value) target = radios[j];
        if (radios[j].value === '') anyRadio = radios[j];
      }
      if (target) {
        if (target.checked && anyRadio) {
          anyRadio.checked = true;
          anyRadio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else if (kind === 'type') {
      
      var tinputs = form.querySelectorAll('input[name*="product_type"]');
      var hit = null;
      for (var m = 0; m < tinputs.length; m++) {
        if (tinputs[m].value === value) { hit = tinputs[m]; break; }
      }
      if (hit) {
        hit.checked = !hit.checked;
        hit.dispatchEvent(new Event('change', { bubbles: true }));
      } else {

        var u = new URL(window.location.href);
        u.searchParams.set('filter.p.product_type', value);
        window.location.href = u.toString();
      }
    }
  });
  syncQfChips();

  (function () {
    var modal = section.querySelector('[data-md9-qa-modal]');
    if (!modal) return;
    var contentEl = modal.querySelector('[data-md9-qa-content]');
    var loadingEl = modal.querySelector('[data-md9-qa-loading]');
    var currentVariantId = null;

    function formatINR(cents) {
      var rupees = Math.round(cents / 100);
      return '₹' + rupees.toLocaleString('en-IN');
    }
    function cleanTitle(raw, vendor) {
      var parts = (raw || '').split('-');
      var keep = [];
      parts.forEach(function (p) {
        p = (p || '').trim();
        if (!p) return;
        if (vendor && p.toLowerCase() === vendor.toLowerCase()) return;
        if (/^\d+$/.test(p)) return;
        if (p.length <= 4 && /\d/.test(p)) return;
        var l = p.toLowerCase();
        if (l === 'men' || l === 'women' || l === 'kids' || l === 'boys' || l === 'girls' || l === 'adult' || l.indexOf('unisex') === 0) return;
        keep.push(p);
      });
      var joined = keep.join(' · ');
      if (!joined) return raw;
      return joined.charAt(0).toUpperCase() + joined.slice(1).toLowerCase();
    }
    function findOptionIndex(product, optName) {
      if (!product.options) return -1;
      for (var i = 0; i < product.options.length; i++) {
        var n = typeof product.options[i] === 'string' ? product.options[i] : (product.options[i].name || '');
        if (n.toLowerCase() === optName.toLowerCase()) return i;
      }
      return -1;
    }

    function openModal(handle) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      contentEl.hidden = true;
      loadingEl.hidden = false;
      currentVariantId = null;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (product) {
          populate(product);
          loadingEl.hidden = true;
          contentEl.hidden = false;
        })
        .catch(function (err) {
          console.warn('Quick add fetch failed:', err);
          closeModal();
        });
    }
    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    function colorToCSS(name) {
      if (!name) return null;
      var lower = String(name).toLowerCase().trim();
      if (lower.indexOf('multi') !== -1 || lower.indexOf('rainbow') !== -1 || lower.indexOf('tie') !== -1 || lower.indexOf('camo') !== -1) {
        return 'conic-gradient(from 0deg, #FF5A1F, #F4D261, #5BA77F, #4F90E0, #B85FBA, #FF5A1F)';
      }
      var map = {
        'black': '#1a1a1a', 'white': '#ffffff', 'cream': '#f5efe0', 'ivory': '#fffff0',
        'navy': '#1a2647', 'blue': '#4f90e0', 'red': '#d63a3a', 'pink': '#f0a7c4',
        'orange': '#ff7a3a', 'yellow': '#f4d261', 'green': '#5ba77f', 'purple': '#9a6fb0',
        'brown': '#7a5a3a', 'tan': '#c4a47a', 'khaki': '#a89968', 'beige': '#e8d8ba',
        'grey': '#888888', 'gray': '#888888', 'silver': '#c4c4c4', 'gold': '#d4af37',
        'bone': '#e8d8ba', 'slate': '#5a6a7a', 'graphite': '#444444', 'olive': '#7a8a3a',
        'stucco': '#c4a47a', 'mushroom': '#a89998', 'taupe': '#a89998'
      };
      if (lower.indexOf('/') !== -1) lower = lower.split('/')[0].trim();
      var words = lower.split(/[\s\-]+/);
      for (var i = 0; i < words.length; i++) {
        if (map[words[i]]) return map[words[i]];
      }
      return '#9a958a';
    }

    function determineUrgency(product) {
      if (product.compare_at_price && product.compare_at_price > product.price) return 'deal';
      var tagsRaw = product.tags;
      var tags = [];
      if (typeof tagsRaw === 'string') tags = tagsRaw.split(',').map(function (t) { return t.trim().toLowerCase(); });
      else if (Array.isArray(tagsRaw)) tags = tagsRaw.map(function (t) { return String(t).toLowerCase(); });
      for (var i = 0; i < tags.length; i++) {
        if (tags[i] === 'bestseller' || tags[i] === 'best-seller' || tags[i] === 'best seller' || tags[i] === 'top-seller') return 'bestseller';
      }
      if (product.created_at) {
        var created = new Date(product.created_at).getTime();
        if (!isNaN(created) && created > Date.now() - 30 * 24 * 60 * 60 * 1000) return 'new';
      }
      return 'trending';
    }

    function populate(product) {
      modal.querySelector('[data-md9-qa-title]').textContent = cleanTitle(product.title, product.vendor);
      var imgEl = modal.querySelector('[data-md9-qa-img]');
      imgEl.src = product.featured_image || (product.images && product.images[0]) || '';
      imgEl.alt = product.title || '';
      modal.querySelector('[data-md9-qa-link]').href = product.url;

      var colorEl = modal.querySelector('[data-md9-qa-color]');
      var colorTextEl = modal.querySelector('[data-md9-qa-color-text]');
      var colorDotEl = modal.querySelector('[data-md9-qa-color-dot]');
      var colorIdx = findOptionIndex(product, 'Color');
      if (colorIdx !== -1 && product.variants && product.variants.length > 0) {
        var c = product.variants[0]['option' + (colorIdx + 1)];
        if (c) {
          colorTextEl.textContent = c;
          var css = colorToCSS(c);
          if (css && css.indexOf('gradient') !== -1) {
            colorDotEl.style.background = css;
          } else {
            colorDotEl.style.background = css || '#9a958a';
          }
          colorEl.hidden = false;
        } else {
          colorEl.hidden = true;
        }
      } else {
        colorEl.hidden = true;
      }

      var urgencyType = determineUrgency(product);
      modal.querySelectorAll('[data-md9-qa-tag]').forEach(function (el) {
        el.hidden = el.getAttribute('data-md9-qa-tag') !== urgencyType;
      });

      var sizesContainer = modal.querySelector('[data-md9-qa-sizes]');
      var sizeSection = modal.querySelector('[data-md9-qa-sizesection]');
      var selectedSizeEl = modal.querySelector('[data-md9-qa-selected-size]');
      var stocknote = modal.querySelector('[data-md9-qa-stocknote]');
      var stocknoteText = modal.querySelector('[data-md9-qa-stocknote-text]');
      sizesContainer.innerHTML = '';
      selectedSizeEl.textContent = '—';
      stocknote.hidden = true;
      stocknote.classList.remove('md9-qa-modal__stocknote--warn');
      var sizeIdx = findOptionIndex(product, 'Size');
      var addBtn = modal.querySelector('[data-md9-qa-add]');
      var addBtnText = addBtn.querySelector('.md9-qa-modal__add-text');
      addBtn.classList.remove('md9-qa-modal__add--success', 'md9-qa-modal__add--ready');
      if (addBtnText) addBtnText.textContent = 'Add to cart';

      if (sizeIdx !== -1 && product.variants && product.variants.length > 0) {
        sizeSection.hidden = false;
        var seen = {};
        var orderedSizes = [];
        product.variants.forEach(function (v) {
          var size = v['option' + (sizeIdx + 1)];
          if (!size || seen[size]) return;
          seen[size] = v;
          orderedSizes.push(size);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'md9-qa-modal__size';
          btn.setAttribute('data-md9-qa-variant', v.id);
          btn.setAttribute('data-md9-qa-size', size);
          btn.textContent = size;
          if (!v.available) {
            btn.disabled = true;
            btn.classList.add('md9-qa-modal__size--oos');
          }
          sizesContainer.appendChild(btn);
        });

        var totalSizes = orderedSizes.length;
        var availableSizes = orderedSizes.filter(function (s) { return seen[s].available; });
        var availCount = availableSizes.length;

        if (totalSizes === 1 && availCount === 1) {
          
          var theVariant = seen[orderedSizes[0]];
          currentVariantId = theVariant.id;
          var theChip = sizesContainer.querySelector('[data-md9-qa-variant="' + theVariant.id + '"]');
          if (theChip) theChip.classList.add('md9-qa-modal__size--on');
          selectedSizeEl.textContent = orderedSizes[0];
          stocknoteText.textContent = "Only 1 size available · Grab it before it's gone";
          stocknote.hidden = false;
          addBtn.disabled = false;
          addBtn.classList.add('md9-qa-modal__add--ready');
        } else if (availCount === 1 && totalSizes > 1) {
          stocknoteText.textContent = 'Only 1 size left · ' + availableSizes[0] + ' — last one';
          stocknote.hidden = false;
          addBtn.disabled = true;
        } else if (availCount === 0) {
          stocknoteText.textContent = 'All sizes sold out';
          stocknote.hidden = false;
          stocknote.classList.add('md9-qa-modal__stocknote--warn');
          addBtn.disabled = true;
        } else if (availCount > 0 && availCount / totalSizes <= 0.5) {
          stocknoteText.textContent = 'Selling fast · Only ' + availCount + ' of ' + totalSizes + ' sizes left';
          stocknote.hidden = false;
          stocknote.classList.add('md9-qa-modal__stocknote--warn');
          addBtn.disabled = true;
        } else {
          addBtn.disabled = true;
        }
      } else {
        
        sizeSection.hidden = true;
        if (product.variants && product.variants.length > 0) {
          currentVariantId = product.variants[0].id;
          addBtn.disabled = !product.variants[0].available;
          if (!addBtn.disabled) addBtn.classList.add('md9-qa-modal__add--ready');
        }
      }

      modal.querySelector('[data-md9-qa-price]').textContent = formatINR(product.price);
      var mrpWrap = modal.querySelector('[data-md9-qa-mrp]');
      var mrpAmt = modal.querySelector('[data-md9-qa-mrp-amt]');
      var offEl = modal.querySelector('[data-md9-qa-off]');
      if (product.compare_at_price && product.compare_at_price > product.price) {
        mrpAmt.textContent = formatINR(product.compare_at_price);
        mrpWrap.hidden = false;
        var off = Math.round((product.compare_at_price - product.price) / product.compare_at_price * 100);
        offEl.textContent = '(' + off + '% off)';
        offEl.hidden = false;
      } else {
        mrpWrap.hidden = true;
        offEl.hidden = true;
      }

      modal.querySelector('[data-md9-qa-feedback]').hidden = true;
    }

    function updateCartBadge() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cartBtn = section.querySelector('.md9-stickybar__btn--cart');
          if (!cartBtn) return;
          if (cart.item_count > 0) {
            cartBtn.classList.add('md9-stickybar__btn--has-items');
            var badge = cartBtn.querySelector('.md9-stickybar__cart-badge');
            if (badge) { badge.textContent = cart.item_count; }
          }
        })
        .catch(function () {});
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-md9-quickadd]');
      if (trigger) {
        e.preventDefault();
        var handle = trigger.getAttribute('data-md9-product-handle');
        if (handle) openModal(handle);
        return;
      }
      if (e.target.closest('[data-md9-qa-close]')) {
        e.preventDefault();
        closeModal();
        return;
      }
      var sizeBtn = e.target.closest('[data-md9-qa-variant]');
      if (sizeBtn && !sizeBtn.disabled) {
        modal.querySelectorAll('.md9-qa-modal__size--on').forEach(function (s) {
          s.classList.remove('md9-qa-modal__size--on');
        });
        sizeBtn.classList.add('md9-qa-modal__size--on');
        currentVariantId = sizeBtn.getAttribute('data-md9-qa-variant');
        modal.querySelector('[data-md9-qa-selected-size]').textContent = sizeBtn.getAttribute('data-md9-qa-size');
        var addBtnReady = modal.querySelector('[data-md9-qa-add]');
        addBtnReady.disabled = false;
        addBtnReady.classList.add('md9-qa-modal__add--ready');
        return;
      }
      if (e.target.closest('[data-md9-qa-add]')) {
        e.preventDefault();
        if (!currentVariantId) return;
        var addBtn = modal.querySelector('[data-md9-qa-add]');
        var addBtnText = addBtn.querySelector('.md9-qa-modal__add-text');
        var feedback = modal.querySelector('[data-md9-qa-feedback]');
        addBtn.disabled = true;
        addBtn.classList.remove('md9-qa-modal__add--ready');
        if (addBtnText) addBtnText.textContent = 'Adding…';
        feedback.classList.remove('md9-qa-modal__feedback--error');
        feedback.hidden = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: currentVariantId, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            if (addBtnText) addBtnText.textContent = '✓ Added';
            addBtn.classList.add('md9-qa-modal__add--success');
            feedback.textContent = 'Added to your cart.';
            feedback.hidden = false;
            updateCartBadge();
            setTimeout(closeModal, 1100);
          })
          .catch(function (err) {
            if (addBtnText) addBtnText.textContent = 'Try again';
            addBtn.disabled = false;
            feedback.textContent = (err && err.description) || 'Could not add. Please try again.';
            feedback.classList.add('md9-qa-modal__feedback--error');
            feedback.hidden = false;
          });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  })();

  var refreshTimer = null;
  var inFlightController = null;

  function buildParams(form) {
    var params = new URLSearchParams();
    var inputs = form.querySelectorAll('input[name], select[name]');
    inputs.forEach(function (el) {
      if (!el.name) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.disabled) return;
      var val = el.value;
      if (val === '' || val == null) return;
      params.append(el.name, val);
    });

    form.querySelectorAll('input[data-md9-size-group]:checked').forEach(function (grp) {
      var codesAttr = grp.getAttribute('data-md9-size-codes') || '';
      var param = grp.getAttribute('data-md9-size-param');
      if (!param || !codesAttr) return;
      codesAttr.split(',').forEach(function (code) {
        code = code.trim();
        if (code) params.append(param, code);
      });
    });

    return params;
  }

  function showLoading(loading) {
    var loadbar = section.querySelector('[data-md9-loadbar]');
    var results = section.querySelector('[data-md9-results]');
    if (loadbar) loadbar.classList.toggle('md9-loadbar--on', loading);
    if (results) results.classList.toggle('md9-main--loading', loading);
  }

  async function refreshFilters(form) {
    if (inFlightController) inFlightController.abort();
    inFlightController = new AbortController();

    var params = buildParams(form);

    var queryStr = params.toString().replace(/\+/g, '%20');
    
    var cacheBuster = '_=' + Date.now();
    var fetchUrl = collectionUrl + '?' + (queryStr ? queryStr + '&' : '') + 'section_id=' + sectionId + '&' + cacheBuster;
    var pushUrl = collectionUrl + (queryStr ? '?' + queryStr : '');

    showLoading(true);
    try {
      var response = await fetch(fetchUrl, {
        signal: inFlightController.signal,
        headers: { 'Accept': 'text/html' }
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newSection = doc.querySelector('[data-md9-section]');
      if (!newSection) throw new Error('No section in response');

      var oldResults = section.querySelector('[data-md9-results]');
      var newResults = newSection.querySelector('[data-md9-results]');
      if (oldResults && newResults) {
        oldResults.innerHTML = newResults.innerHTML;
      }

      setupLoadMore();

      fetchSecondaryIfNeeded();

      syncQfChips();

      applySizeSortOrder();

      updateStickyBarActiveStates();

      updateDiscountCounts();
      applyDiscountFilter();

      var newCountEl = newSection.querySelector('[data-md9-result-count]');
      var newCountText = newCountEl ? newCountEl.textContent : '';
      section.querySelectorAll('[data-md9-result-count]').forEach(function (el) {
        if (newCountText) el.textContent = newCountText;
      });

      try {
        history.replaceState(null, '', pushUrl);
      } catch (e) {}

    } catch (err) {
      if (err.name !== 'AbortError') {
        console.warn('Live filter refresh failed; falling back to form submit:', err);
        form.submit();
      }
    } finally {
      showLoading(false);
    }
  }

  function scheduleRefresh(form) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshFilters(form); }, 250);
  }

  section.addEventListener('change', function (e) {
    var input = e.target;
    if (!input) return;
    
    var hasName = !!input.name;
    var isSizeGroup = input.hasAttribute && input.hasAttribute('data-md9-size-group');
    if (!hasName && !isSizeGroup) return;
    var form = input.closest('[data-md9-filter-form]');
    if (!form) return;
    scheduleRefresh(form);
  });

  section.querySelectorAll('[data-md9-fallback-apply]').forEach(function (b) {
    b.style.display = 'none';
  });

  section.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-md9-close-drawer-after]');
    if (!btn) return;
    e.preventDefault();
    var dr = section.querySelector('[data-md9-drawer]');
    if (dr) {
      dr.hidden = true;
      document.body.style.overflow = '';
    }
  });

  var drawer = section.querySelector('[data-md9-drawer]');
  section.querySelectorAll('[data-md9-open-drawer]').forEach(function (b) {
    b.addEventListener('click', function () {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });
  drawer && drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-md9-close]')) {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }
    var tab = e.target.closest('[data-md9-tab]');
    if (tab) {
      var target = tab.getAttribute('data-md9-tab');
      drawer.querySelectorAll('[data-md9-tab]').forEach(function (t) {
        t.classList.toggle('md9-tab--on', t.getAttribute('data-md9-tab') === target);
      });
      drawer.querySelectorAll('[data-md9-panel]').forEach(function (p) {
        var on = p.getAttribute('data-md9-panel') === target;
        p.classList.toggle('md9-panel--on', on);
        p.hidden = !on;
      });
    }
  });

  section.addEventListener('click', function (e) {
    var sizetab = e.target.closest('[data-md9-sizetab]');
    if (!sizetab) return;
    var target = sizetab.getAttribute('data-md9-sizetab');
    
    var scope = sizetab.closest('.md9-size-group, .md9-panel');
    if (!scope) scope = section;
    scope.querySelectorAll('[data-md9-sizetab]').forEach(function (t) {
      t.classList.toggle('md9-sizetab--on', t.getAttribute('data-md9-sizetab') === target);
    });
    scope.querySelectorAll('[data-md9-sizetab-pane]').forEach(function (p) {
      p.classList.toggle('md9-sizetab-pane--on', p.getAttribute('data-md9-sizetab-pane') === target);
    });
  });

  var modal = section.querySelector('[data-md9-sizechart]');
  section.addEventListener('click', function (e) {
    if (e.target.closest('[data-md9-open-sizechart]')) {
      e.preventDefault();
      if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-md9-sizechart-close]')) {
      if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
    }
    
    var vt = e.target.closest('[data-md9-vendor]');
    if (vt && modal) {
      var v = vt.getAttribute('data-md9-vendor');
      modal.querySelectorAll('[data-md9-vendor]').forEach(function (b) {
        b.classList.toggle('md9-vendor-tab--on', b.getAttribute('data-md9-vendor') === v);
      });
      modal.querySelectorAll('[data-md9-vendor-pane]').forEach(function (p) {
        var on = p.getAttribute('data-md9-vendor-pane') === v;
        p.classList.toggle('md9-modal__vendor--on', on);
        p.hidden = !on;
      });
    }
  });

  var sheet = section.querySelector('[data-md9-sheet]');
  section.querySelectorAll('[data-md9-open-sort]').forEach(function (b) {
    b.addEventListener('click', function () {
      sheet.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });
  sheet && sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-md9-sheet-close]')) {
      sheet.hidden = true;
      document.body.style.overflow = '';
    }
  });

  section.querySelectorAll('form').forEach(function (form) {
    form.addEventListener('submit', function () {
      
      form.querySelectorAll('input[data-md9-injected-unisex]').forEach(function (el) { el.remove(); });
      form.querySelectorAll('input[data-md9-injected-size]').forEach(function (el) { el.remove(); });

      form.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        if ((r.name || '').indexOf('price.lte') !== -1 && r.value === '') {
          r.disabled = true;
          setTimeout(function () { r.disabled = false; }, 100);
        }
      });

      form.querySelectorAll('input[data-md9-size-group]:checked').forEach(function (grp) {
        var paramName = grp.getAttribute('data-md9-size-param');
        var codes = (grp.getAttribute('data-md9-size-codes') || '').split(',');
        codes.forEach(function (code) {
          code = code.trim();
          if (!code) return;
          var h = document.createElement('input');
          h.type = 'hidden';
          h.name = paramName;
          h.value = code;
          h.setAttribute('data-md9-injected-size', '1');
          form.appendChild(h);
        });
      });

      var genderInputs = form.querySelectorAll('[data-md9-gender-input]:checked');
      if (genderInputs.length === 0) return;
      var hasMenOrWomen = false;
      var paramName = '';
      genderInputs.forEach(function (i) {
        var vlow = (i.value || '').toLowerCase();
        var llow = ((i.parentElement && i.parentElement.textContent) || '').toLowerCase();
        
        var isMale = vlow === 'male' || llow.indexOf('men') !== -1 && llow.indexOf('women') === -1;
        var isFemale = vlow === 'female' || llow.indexOf('women') !== -1;
        if (isMale || isFemale) {
          hasMenOrWomen = true;
          paramName = i.name;
        }
      });
      if (!hasMenOrWomen) return;
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = paramName;
      inp.value = 'unisex';
      inp.setAttribute('data-md9-injected-unisex', 'true');
      form.appendChild(inp);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) { drawer.hidden = true; document.body.style.overflow = ''; }
    if (sheet && !sheet.hidden) { sheet.hidden = true; document.body.style.overflow = ''; }
    if (modal && !modal.hidden) { modal.hidden = true; document.body.style.overflow = ''; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-smart-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mdp]');
  if (!root) return;

  var mainImg = root.querySelector('[data-mdp-main]');
  root.querySelectorAll('[data-mdp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg) mainImg.src = t.getAttribute('data-src');
      root.querySelectorAll('[data-mdp-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-mdp-variants]').textContent.trim()); } catch (e) { variants = []; }

  var stock = {};
  try { stock = JSON.parse(root.querySelector('[data-mdp-stock]').textContent.trim()); } catch (e) { stock = {}; }
  var LOW_STOCK = 5;

  var idInput = root.querySelector('[data-mdp-variant-id]');
  var priceEl = root.querySelector('[data-mdp-price]');
  var mrpEl = root.querySelector('[data-mdp-mrp]');
  var saveEl = root.querySelector('[data-mdp-save]');
  var saveAmtEl = root.querySelector('[data-mdp-save-amt]');
  var atcBtn = root.querySelector('[data-mdp-atc]');
  var atcText = root.querySelector('[data-mdp-atc-text]');
  var stickyPrice = root.querySelector('[data-mdp-sticky-price]');
  var stickyMrp = root.querySelector('[data-mdp-sticky-mrp]');

  var selected = {};
  root.querySelectorAll('[data-mdp-opt].is-selected').forEach(function (b) {
    selected[b.getAttribute('data-position')] = b.getAttribute('data-value');
  });

  function fmtMoney(cents) {
    var n = (cents / 100);
    return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s){ return (s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  function findVariant() {
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      for (var pos in selected) { if (opts[pos - 1] !== selected[pos]) return false; }
      return true;
    });
  }

  // Resolve the variant for a hypothetical selection (current picks + one override)
  function variantFor(sel) {
    return variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      for (var pos in sel) { if (opts[pos - 1] !== sel[pos]) return false; }
      return true;
    });
  }

  // Show "N left" on each chip when that variant is low, and grey out sold-out ones
  function updateChipStock() {
    root.querySelectorAll('[data-mdp-opt]').forEach(function (chip) {
      var pos = chip.getAttribute('data-position');
      var cand = {};
      for (var p in selected) { cand[p] = selected[p]; }
      cand[pos] = chip.getAttribute('data-value');
      var v = variantFor(cand);
      var tag = chip.querySelector('.mdp__chip-left');
      var label = '';
      var soldout = false;
      if (v && stock[v.id]) {
        var s = stock[v.id];
        if (!s.a || (s.t && s.q <= 0)) { soldout = true; }
        else if (s.t && s.q > 0 && s.q < LOW_STOCK) { label = s.q + ' left'; }
      } else if (v && v.available === false) {
        soldout = true;
      }
      if (soldout) { chip.classList.add('is-soldout'); } else { chip.classList.remove('is-soldout'); }
      var tagText = soldout ? 'Sold out' : label;
      if (tagText) {
        if (!tag) { tag = document.createElement('span'); tag.className = 'mdp__chip-left'; chip.appendChild(tag); }
        tag.textContent = tagText;
      } else if (tag) {
        tag.remove();
      }
    });
  }

  function updateVariant() {
    updateChipStock();
    var v = findVariant();
    if (!v) return;
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = fmtMoney(v.price);
    if (stickyPrice) stickyPrice.textContent = fmtMoney(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (mrpEl) { mrpEl.style.display = onSale ? '' : 'none'; if (onSale) mrpEl.textContent = fmtMoney(v.compare_at_price); }
    if (stickyMrp) { stickyMrp.style.display = onSale ? '' : 'none'; if (onSale) stickyMrp.textContent = fmtMoney(v.compare_at_price); }
    if (saveEl && onSale) { saveEl.style.display = ''; saveEl.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF'; }
    else if (saveEl) { saveEl.style.display = 'none'; }
    if (saveAmtEl && onSale) { saveAmtEl.textContent = fmtMoney(v.compare_at_price - v.price); }
    if (atcBtn) { atcBtn.disabled = !v.available; if (atcText) atcText.textContent = v.available ? 'Add to cart' : 'Sold out'; }
  }

  root.querySelectorAll('[data-mdp-opt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = btn.getAttribute('data-position');
      selected[pos] = btn.getAttribute('data-value');
      root.querySelectorAll('[data-mdp-opt][data-position="' + pos + '"]').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      updateVariant();
    });
  });

  var qty = root.querySelector('[data-mdp-qty]');
  var minus = root.querySelector('[data-mdp-qty-minus]');
  var plus = root.querySelector('[data-mdp-qty-plus]');
  if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
  if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

  /* Add to cart via AJAX so the header count updates instantly and the
     mini-cart drawer opens (handled globally in the header). No dependency
     on the theme's flyout, which isn't loaded on this custom section. */
  var pform = atcBtn ? atcBtn.closest('form') : null;
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var origText = atcBtn ? atcBtn.querySelector('[data-mdp-atc-text]') : null;
      var prevLabel = origText ? origText.textContent : '';
      if (atcBtn) { atcBtn.disabled = true; atcBtn.classList.add('is-loading'); }
      if (origText) origText.textContent = 'Adding…';
      var done = function () {
        if (atcBtn) { atcBtn.disabled = false; atcBtn.classList.remove('is-loading'); }
        if (origText) origText.textContent = prevLabel;
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: new FormData(pform)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          done();
          if (!res.ok) {
            alert((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.');
          }
          // header count + mini-cart drawer are handled globally on /cart/add
        })
        .catch(function () { done(); pform.submit(); });
    });
  }

  var sticky = root.querySelector('[data-mdp-sticky]');
  var stickyAtc = root.querySelector('[data-mdp-sticky-atc]');
  var buyBox = root.querySelector('.mdp__buy');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '0px 0px -100px 0px' });
    io.observe(buyBox);
  }
  if (stickyAtc && atcBtn) { stickyAtc.addEventListener('click', function () { atcBtn.click(); }); }

  var pabRow = root.querySelector('[data-mdp-pab-row]');
  var pabSec = root.querySelector('[data-mdp-pab]');
  var pid = root.getAttribute('data-product-id');
  function pabCard(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=320';
    var mrp = (p.compare_at_price && p.compare_at_price > p.price) ? '<span class="mdp-pab__mrp">' + fmtMoney(p.compare_at_price) + '</span>' : '';
    return '<a class="mdp-pab__card" href="' + esc(p.url) + '">' +
      '<div class="mdp-pab__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="mdp-pab__info"><div class="mdp-pab__title">' + esc(p.title) + '</div>' +
      '<div class="mdp-pab__price">' + fmtMoney(p.price) + mrp + '</div></div></a>';
  }
  if (pabRow && pid) {
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.products && d.products.length) { pabRow.innerHTML = d.products.map(pabCard).join(''); }
        if (!pabRow.children.length && pabSec) pabSec.style.display = 'none';
      })
      .catch(function () { if (pabRow && !pabRow.children.length && pabSec) pabSec.style.display = 'none'; });
  }

  var scModal = root.querySelector('[data-mdp-sc]');
  function scOpen(){ if(scModal){ scModal.hidden=false; document.documentElement.style.overflow='hidden'; } }
  function scClose(){ if(scModal){ scModal.hidden=true; document.documentElement.style.overflow=''; } }
  root.querySelectorAll('[data-mdp-sc-open]').forEach(function(b){ b.addEventListener('click', scOpen); });
  root.querySelectorAll('[data-mdp-sc-close]').forEach(function(b){ b.addEventListener('click', scClose); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && scModal && !scModal.hidden) scClose(); });

  updateVariant();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-smart-search-full"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-md9-section]');
  if (!section) return;
  section.classList.add('md9--js');
  var sectionId = section.getAttribute('data-section-id');
  var collectionUrl = section.getAttribute('data-md9-collection-url') || window.location.pathname;

  var loadMoreObserver = null;
  var loadMoreInFlight = false;

  function getSentinel() { return section.querySelector('[data-md9-load-more]'); }

  function setupLoadMore() {
    var sentinel = getSentinel();
    if (!sentinel || !('IntersectionObserver' in window)) return;
    if (loadMoreObserver) loadMoreObserver.disconnect();
    loadMoreObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !loadMoreInFlight) {
          loadNextPage(entry.target);
        }
      });
    }, { rootMargin: '400px 0px' });
    loadMoreObserver.observe(sentinel);
  }

  async function loadNextPage(sentinel) {
    if (loadMoreInFlight) return;
    var nextUrl = sentinel.getAttribute('data-md9-next-url');
    if (!nextUrl) return;
    loadMoreInFlight = true;

    try {
      var sep = nextUrl.indexOf('?') >= 0 ? '&' : '?';
      var url = nextUrl + sep + 'section_id=' + sectionId + '&_=' + Date.now();
      var res = await fetch(url, { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var newGrids = doc.querySelectorAll('[data-md9-results] .md9-grid');
      var curGrids = section.querySelectorAll('[data-md9-results] .md9-grid');
      newGrids.forEach(function (newGrid, idx) {
        var sectionTag = newGrid.getAttribute('data-md9-grid-section');
        var target = null;
        if (sectionTag) {
          target = section.querySelector('[data-md9-results] .md9-grid[data-md9-grid-section="' + sectionTag + '"]');
        }
        if (!target) {
          target = curGrids[idx] || curGrids[curGrids.length - 1];
        }
        if (!target) return;
        var addedCount = 0;
        Array.from(newGrid.children).forEach(function (item) {
          target.appendChild(item);
          addedCount++;
        });
        
        applySizeSortOrder(target);
        
        updateDiscountCounts();
        applyDiscountFilter();
        
        if (sectionTag && addedCount > 0) {
          var countEl = section.querySelector('[data-md9-section-count="' + sectionTag + '"]');
          if (countEl) {
            var totalItems = target.children.length;
            countEl.textContent = '(' + totalItems + ')';
          }
        }
      });

      var newSentinel = doc.querySelector('[data-md9-load-more]');
      var newFallback = doc.querySelector('[data-md9-paginate-fallback]');
      if (loadMoreObserver) loadMoreObserver.unobserve(sentinel);

      if (newSentinel) {
        
        sentinel.replaceWith(newSentinel);
        
        var curFallback = section.querySelector('[data-md9-paginate-fallback]');
        if (curFallback && newFallback) curFallback.replaceWith(newFallback);
        
        setupLoadMore();
      } else {
        
        sentinel.remove();
        var fb = section.querySelector('[data-md9-paginate-fallback]');
        if (fb) fb.remove();
      }
    } catch (err) {
      console.warn('Load more failed:', err);
      
      var sNow = getSentinel();
      if (sNow && loadMoreObserver) loadMoreObserver.observe(sNow);
    } finally {
      loadMoreInFlight = false;
    }
  }

  setupLoadMore();

  var SECONDARY_INITIAL_PAGES = 10; 
  var secondaryUserConfirmedMore = false;

  function fetchSecondaryIfNeeded() {
    var secondaryGrid = section.querySelector('[data-md9-secondary-fetch-value]');
    if (!secondaryGrid) return;
    var secondaryValue = secondaryGrid.getAttribute('data-md9-secondary-fetch-value');
    if (!secondaryValue) return;
    
    secondaryGrid.removeAttribute('data-md9-secondary-fetch-value');
    
    secondaryUserConfirmedMore = false;
    
    var oldBtn = section.querySelector('[data-md9-secondary-load-more-btn]');
    if (oldBtn) oldBtn.remove();
    
    fetchSecondaryPage(secondaryValue, 1, secondaryGrid);
  }

  function fetchSecondaryPage(secondaryValue, page, secondaryGrid) {
    var fetchUrl = collectionUrl
      + '?filter.v.option.gender=' + encodeURIComponent(secondaryValue)
      + '&page=' + page
      + '&section_id=' + sectionId
      + '&_=' + Date.now();

    fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-md9-results] .md9-grid');
        if (!newGrid) return;
        var items = Array.from(newGrid.children);

        if (items.length === 0 && page === 1) {
          
          var hdr = section.querySelector('[data-md9-section-hdr="secondary"]');
          if (hdr) hdr.style.display = 'none';
          secondaryGrid.style.display = 'none';
          return;
        }

        items.forEach(function (item) { secondaryGrid.appendChild(item); });
        applySizeSortOrder(secondaryGrid);
        
        updateDiscountCounts();
        applyDiscountFilter();

        var hasMore = doc.querySelector('[data-md9-load-more]') !== null;
        if (!hasMore) return; 

        if (page < SECONDARY_INITIAL_PAGES || secondaryUserConfirmedMore) {
          
          fetchSecondaryPage(secondaryValue, page + 1, secondaryGrid);
        } else {
          
          showSecondaryLoadMoreButton(secondaryValue, page + 1, secondaryGrid);
        }
      })
      .catch(function (err) {
        console.warn('Secondary fetch failed (page ' + page + '):', err);
      });
  }

  function showSecondaryLoadMoreButton(secondaryValue, nextPage, secondaryGrid) {
    
    var existing = section.querySelector('[data-md9-secondary-load-more-btn]');
    if (existing) existing.remove();

    var btn = document.createElement('button');
    btn.setAttribute('data-md9-secondary-load-more-btn', '');
    btn.className = 'md9-secondary-load-more-btn';
    btn.type = 'button';
    btn.textContent = 'Show more products';

    if (secondaryGrid.parentNode) {
      secondaryGrid.parentNode.insertBefore(btn, secondaryGrid.nextSibling);
    }

    btn.addEventListener('click', function () {
      
      secondaryUserConfirmedMore = true;
      btn.remove();
      fetchSecondaryPage(secondaryValue, nextPage, secondaryGrid);
    });
  }

  fetchSecondaryIfNeeded();

  function applySizeSortOrder(scope) {
    scope = scope || section;

    var url, sortVal;
    try { url = new URL(window.location.href); sortVal = url.searchParams.get('sort_by'); }
    catch (e) { sortVal = null; }
    var sortActive = sortVal && sortVal !== '' && sortVal !== 'manual';

    // Walk each grid's children in DOM order. Break panels (.md9-grid__break)
    // anchor "segment" boundaries; products sort by size-count WITHIN their
    // segment. This keeps the stories/engage breaks pinned to their DOM
    // position instead of floating to order:0 (which caused the glitch).
    var grids = scope.querySelectorAll('.md9-grid');
    if (!grids.length && scope.classList && scope.classList.contains('md9-grid')) {
      grids = [scope];
    }
    grids.forEach(function (grid) {
      var seg = 0;
      Array.prototype.forEach.call(grid.children, function (el) {
        if (el.classList.contains('md9-grid__break')) {
          // break sits at the end of the current segment, before the next
          el.style.order = String(seg * 1000 + 999);
          seg++;
          return;
        }
        if (!el.hasAttribute || !el.hasAttribute('data-md9-size-count')) return;
        if (sortActive) {
          el.style.order = String(seg * 1000);
        } else {
          var c = parseInt(el.getAttribute('data-md9-size-count') || '0', 10);
          if (c > 99) c = 99;
          // within segment, higher size-count → lower order → earlier
          el.style.order = String(seg * 1000 + (100 - c));
        }
      });
    });
  }
  applySizeSortOrder();

  function updateStickyBarActiveStates() {
    var filterBtn = section.querySelector('[data-md9-open-drawer]');
    if (filterBtn) {
      var url, hasFilter = false;
      try { url = new URL(window.location.href); } catch (e) {}
      if (url) {
        url.searchParams.forEach(function (v, k) {
          if (k && k.indexOf('filter.') === 0 && v !== '') hasFilter = true;
        });
      }
      
      if (!hasFilter) {
        var form = section.querySelector('[data-md9-filter-form]');
        if (form) {
          var inputs = form.querySelectorAll('input[name^="filter."]:checked');
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value !== '') { hasFilter = true; break; }
          }
        }
      }
      
      if (!hasFilter) {
        var anyDiscount = section.querySelector('[data-md9-discount-bucket]:checked');
        if (anyDiscount) hasFilter = true;
      }
      filterBtn.classList.toggle('md9-stickybar__btn--has-filter', hasFilter);
    }
  }
  updateStickyBarActiveStates();

  function bucketOf(pct) {
    if (pct <= 0) return null;
    if (pct < 25) return 'under25';
    if (pct < 50) return '25to50';
    if (pct < 75) return '50to75';
    return '75plus';
  }
  function updateDiscountCounts() {
    var counts = { under25: 0, '25to50': 0, '50to75': 0, '75plus': 0 };
    section.querySelectorAll('[data-md9-discount]').forEach(function (item) {
      var pct = parseInt(item.getAttribute('data-md9-discount') || '0', 10);
      var b = bucketOf(pct);
      if (b) counts[b]++;
    });
    section.querySelectorAll('[data-md9-discount-count]').forEach(function (badge) {
      var bk = badge.getAttribute('data-md9-discount-count');
      var n = counts[bk] || 0;
      badge.textContent = n > 0 ? '(' + n + ')' : '';
    });
    section.querySelectorAll('[data-md9-discount-bucket-label]').forEach(function (label) {
      var bk = label.getAttribute('data-md9-discount-bucket-label');
      var n = counts[bk] || 0;
      label.style.display = n > 0 ? '' : 'none';
      
      if (n === 0) {
        var input = label.querySelector('[data-md9-discount-bucket]');
        if (input && input.checked) { input.checked = false; }
      }
    });
    var total = counts.under25 + counts['25to50'] + counts['50to75'] + counts['75plus'];
    section.querySelectorAll('[data-md9-discount-group]').forEach(function (group) {
      group.style.display = total > 0 ? '' : 'none';
    });
  }
  function applyDiscountFilter() {
    var checked = section.querySelectorAll('[data-md9-discount-bucket]:checked');
    if (checked.length === 0) {
      section.querySelectorAll('[data-md9-discount-hidden]').forEach(function (item) {
        item.removeAttribute('data-md9-discount-hidden');
      });
      return;
    }
    var allowed = {};
    checked.forEach(function (i) { allowed[i.getAttribute('data-md9-discount-bucket')] = true; });
    section.querySelectorAll('[data-md9-discount]').forEach(function (item) {
      var pct = parseInt(item.getAttribute('data-md9-discount') || '0', 10);
      var b = bucketOf(pct);
      if (b && allowed[b]) item.removeAttribute('data-md9-discount-hidden');
      else item.setAttribute('data-md9-discount-hidden', '');
    });
  }
  function syncDiscountInputs(source) {
    var bucket = source.getAttribute('data-md9-discount-bucket');
    var checked = source.checked;
    section.querySelectorAll('[data-md9-discount-bucket="' + bucket + '"]').forEach(function (input) {
      if (input !== source) input.checked = checked;
    });
  }

  section.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-md9-discount-bucket]')) {
      e.stopPropagation();
      syncDiscountInputs(e.target);
      applyDiscountFilter();
      updateStickyBarActiveStates();
    }
  }, true);
  updateDiscountCounts();
  applyDiscountFilter();

  function syncQfChips() {
    var qf = section.querySelector('[data-md9-quickfilters]');
    if (!qf) return;
    var form = section.querySelector('[data-md9-filter-form]');
    if (!form) return;
    qf.querySelectorAll('[data-md9-qf]').forEach(function (chip) {
      var kind = chip.getAttribute('data-md9-qf');
      var value = chip.getAttribute('data-md9-value');
      var matched = false;
      if (kind === 'gender') {
        var inputs = form.querySelectorAll('input[name*="gender"]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === value && inputs[i].checked) { matched = true; break; }
        }
      } else if (kind === 'price') {
        var radios = form.querySelectorAll('input[name*="price.lte"]');
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].value === value && radios[j].checked) { matched = true; break; }
        }
      } else if (kind === 'type') {
        var tinputs = form.querySelectorAll('input[name*="product_type"]');
        for (var k = 0; k < tinputs.length; k++) {
          if (tinputs[k].value === value && tinputs[k].checked) { matched = true; break; }
        }
      }
      chip.classList.toggle('md9-qf-chip--on', matched);
    });
  }
  section.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-md9-qf]');
    if (!chip) return;
    e.preventDefault();
    var kind = chip.getAttribute('data-md9-qf');
    var value = chip.getAttribute('data-md9-value');
    var form = section.querySelector('[data-md9-filter-form]');
    if (!form) return;
    if (kind === 'gender') {
      var inputs = form.querySelectorAll('input[name*="gender"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) {
          inputs[i].checked = !inputs[i].checked;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    } else if (kind === 'price') {
      var radios = form.querySelectorAll('input[name*="price.lte"]');
      var target = null;
      var anyRadio = null;
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].value === value) target = radios[j];
        if (radios[j].value === '') anyRadio = radios[j];
      }
      if (target) {
        if (target.checked && anyRadio) {
          anyRadio.checked = true;
          anyRadio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else if (kind === 'type') {
      
      var tinputs = form.querySelectorAll('input[name*="product_type"]');
      var hit = null;
      for (var m = 0; m < tinputs.length; m++) {
        if (tinputs[m].value === value) { hit = tinputs[m]; break; }
      }
      if (hit) {
        hit.checked = !hit.checked;
        hit.dispatchEvent(new Event('change', { bubbles: true }));
      } else {

        var u = new URL(window.location.href);
        u.searchParams.set('filter.p.product_type', value);
        window.location.href = u.toString();
      }
    }
  });
  syncQfChips();

  (function () {
    var modal = section.querySelector('[data-md9-qa-modal]');
    if (!modal) return;
    var contentEl = modal.querySelector('[data-md9-qa-content]');
    var loadingEl = modal.querySelector('[data-md9-qa-loading]');
    var currentVariantId = null;

    function formatINR(cents) {
      var rupees = Math.round(cents / 100);
      return '₹' + rupees.toLocaleString('en-IN');
    }
    function cleanTitle(raw, vendor) {
      var parts = (raw || '').split('-');
      var keep = [];
      parts.forEach(function (p) {
        p = (p || '').trim();
        if (!p) return;
        if (vendor && p.toLowerCase() === vendor.toLowerCase()) return;
        if (/^\d+$/.test(p)) return;
        if (p.length <= 4 && /\d/.test(p)) return;
        var l = p.toLowerCase();
        if (l === 'men' || l === 'women' || l === 'kids' || l === 'boys' || l === 'girls' || l === 'adult' || l.indexOf('unisex') === 0) return;
        keep.push(p);
      });
      var joined = keep.join(' · ');
      if (!joined) return raw;
      return joined.charAt(0).toUpperCase() + joined.slice(1).toLowerCase();
    }
    function findOptionIndex(product, optName) {
      if (!product.options) return -1;
      for (var i = 0; i < product.options.length; i++) {
        var n = typeof product.options[i] === 'string' ? product.options[i] : (product.options[i].name || '');
        if (n.toLowerCase() === optName.toLowerCase()) return i;
      }
      return -1;
    }

    function openModal(handle) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      contentEl.hidden = true;
      loadingEl.hidden = false;
      currentVariantId = null;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (product) {
          populate(product);
          loadingEl.hidden = true;
          contentEl.hidden = false;
        })
        .catch(function (err) {
          console.warn('Quick add fetch failed:', err);
          closeModal();
        });
    }
    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    function colorToCSS(name) {
      if (!name) return null;
      var lower = String(name).toLowerCase().trim();
      if (lower.indexOf('multi') !== -1 || lower.indexOf('rainbow') !== -1 || lower.indexOf('tie') !== -1 || lower.indexOf('camo') !== -1) {
        return 'conic-gradient(from 0deg, #FF5A1F, #F4D261, #5BA77F, #4F90E0, #B85FBA, #FF5A1F)';
      }
      var map = {
        'black': '#1a1a1a', 'white': '#ffffff', 'cream': '#f5efe0', 'ivory': '#fffff0',
        'navy': '#1a2647', 'blue': '#4f90e0', 'red': '#d63a3a', 'pink': '#f0a7c4',
        'orange': '#ff7a3a', 'yellow': '#f4d261', 'green': '#5ba77f', 'purple': '#9a6fb0',
        'brown': '#7a5a3a', 'tan': '#c4a47a', 'khaki': '#a89968', 'beige': '#e8d8ba',
        'grey': '#888888', 'gray': '#888888', 'silver': '#c4c4c4', 'gold': '#d4af37',
        'bone': '#e8d8ba', 'slate': '#5a6a7a', 'graphite': '#444444', 'olive': '#7a8a3a',
        'stucco': '#c4a47a', 'mushroom': '#a89998', 'taupe': '#a89998'
      };
      if (lower.indexOf('/') !== -1) lower = lower.split('/')[0].trim();
      var words = lower.split(/[\s\-]+/);
      for (var i = 0; i < words.length; i++) {
        if (map[words[i]]) return map[words[i]];
      }
      return '#9a958a';
    }

    function determineUrgency(product) {
      if (product.compare_at_price && product.compare_at_price > product.price) return 'deal';
      var tagsRaw = product.tags;
      var tags = [];
      if (typeof tagsRaw === 'string') tags = tagsRaw.split(',').map(function (t) { return t.trim().toLowerCase(); });
      else if (Array.isArray(tagsRaw)) tags = tagsRaw.map(function (t) { return String(t).toLowerCase(); });
      for (var i = 0; i < tags.length; i++) {
        if (tags[i] === 'bestseller' || tags[i] === 'best-seller' || tags[i] === 'best seller' || tags[i] === 'top-seller') return 'bestseller';
      }
      if (product.created_at) {
        var created = new Date(product.created_at).getTime();
        if (!isNaN(created) && created > Date.now() - 30 * 24 * 60 * 60 * 1000) return 'new';
      }
      return 'trending';
    }

    function populate(product) {
      modal.querySelector('[data-md9-qa-title]').textContent = cleanTitle(product.title, product.vendor);
      var imgEl = modal.querySelector('[data-md9-qa-img]');
      imgEl.src = product.featured_image || (product.images && product.images[0]) || '';
      imgEl.alt = product.title || '';
      modal.querySelector('[data-md9-qa-link]').href = product.url;

      var colorEl = modal.querySelector('[data-md9-qa-color]');
      var colorTextEl = modal.querySelector('[data-md9-qa-color-text]');
      var colorDotEl = modal.querySelector('[data-md9-qa-color-dot]');
      var colorIdx = findOptionIndex(product, 'Color');
      if (colorIdx !== -1 && product.variants && product.variants.length > 0) {
        var c = product.variants[0]['option' + (colorIdx + 1)];
        if (c) {
          colorTextEl.textContent = c;
          var css = colorToCSS(c);
          if (css && css.indexOf('gradient') !== -1) {
            colorDotEl.style.background = css;
          } else {
            colorDotEl.style.background = css || '#9a958a';
          }
          colorEl.hidden = false;
        } else {
          colorEl.hidden = true;
        }
      } else {
        colorEl.hidden = true;
      }

      var urgencyType = determineUrgency(product);
      modal.querySelectorAll('[data-md9-qa-tag]').forEach(function (el) {
        el.hidden = el.getAttribute('data-md9-qa-tag') !== urgencyType;
      });

      var sizesContainer = modal.querySelector('[data-md9-qa-sizes]');
      var sizeSection = modal.querySelector('[data-md9-qa-sizesection]');
      var selectedSizeEl = modal.querySelector('[data-md9-qa-selected-size]');
      var stocknote = modal.querySelector('[data-md9-qa-stocknote]');
      var stocknoteText = modal.querySelector('[data-md9-qa-stocknote-text]');
      sizesContainer.innerHTML = '';
      selectedSizeEl.textContent = '—';
      stocknote.hidden = true;
      stocknote.classList.remove('md9-qa-modal__stocknote--warn');
      var sizeIdx = findOptionIndex(product, 'Size');
      var addBtn = modal.querySelector('[data-md9-qa-add]');
      var addBtnText = addBtn.querySelector('.md9-qa-modal__add-text');
      addBtn.classList.remove('md9-qa-modal__add--success', 'md9-qa-modal__add--ready');
      if (addBtnText) addBtnText.textContent = 'Add to cart';

      if (sizeIdx !== -1 && product.variants && product.variants.length > 0) {
        sizeSection.hidden = false;
        var seen = {};
        var orderedSizes = [];
        product.variants.forEach(function (v) {
          var size = v['option' + (sizeIdx + 1)];
          if (!size || seen[size]) return;
          seen[size] = v;
          orderedSizes.push(size);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'md9-qa-modal__size';
          btn.setAttribute('data-md9-qa-variant', v.id);
          btn.setAttribute('data-md9-qa-size', size);
          btn.textContent = size;
          if (!v.available) {
            btn.disabled = true;
            btn.classList.add('md9-qa-modal__size--oos');
          }
          sizesContainer.appendChild(btn);
        });

        var totalSizes = orderedSizes.length;
        var availableSizes = orderedSizes.filter(function (s) { return seen[s].available; });
        var availCount = availableSizes.length;

        if (totalSizes === 1 && availCount === 1) {
          
          var theVariant = seen[orderedSizes[0]];
          currentVariantId = theVariant.id;
          var theChip = sizesContainer.querySelector('[data-md9-qa-variant="' + theVariant.id + '"]');
          if (theChip) theChip.classList.add('md9-qa-modal__size--on');
          selectedSizeEl.textContent = orderedSizes[0];
          stocknoteText.textContent = "Only 1 size available · Grab it before it's gone";
          stocknote.hidden = false;
          addBtn.disabled = false;
          addBtn.classList.add('md9-qa-modal__add--ready');
        } else if (availCount === 1 && totalSizes > 1) {
          stocknoteText.textContent = 'Only 1 size left · ' + availableSizes[0] + ' — last one';
          stocknote.hidden = false;
          addBtn.disabled = true;
        } else if (availCount === 0) {
          stocknoteText.textContent = 'All sizes sold out';
          stocknote.hidden = false;
          stocknote.classList.add('md9-qa-modal__stocknote--warn');
          addBtn.disabled = true;
        } else if (availCount > 0 && availCount / totalSizes <= 0.5) {
          stocknoteText.textContent = 'Selling fast · Only ' + availCount + ' of ' + totalSizes + ' sizes left';
          stocknote.hidden = false;
          stocknote.classList.add('md9-qa-modal__stocknote--warn');
          addBtn.disabled = true;
        } else {
          addBtn.disabled = true;
        }
      } else {
        
        sizeSection.hidden = true;
        if (product.variants && product.variants.length > 0) {
          currentVariantId = product.variants[0].id;
          addBtn.disabled = !product.variants[0].available;
          if (!addBtn.disabled) addBtn.classList.add('md9-qa-modal__add--ready');
        }
      }

      modal.querySelector('[data-md9-qa-price]').textContent = formatINR(product.price);
      var mrpWrap = modal.querySelector('[data-md9-qa-mrp]');
      var mrpAmt = modal.querySelector('[data-md9-qa-mrp-amt]');
      var offEl = modal.querySelector('[data-md9-qa-off]');
      if (product.compare_at_price && product.compare_at_price > product.price) {
        mrpAmt.textContent = formatINR(product.compare_at_price);
        mrpWrap.hidden = false;
        var off = Math.round((product.compare_at_price - product.price) / product.compare_at_price * 100);
        offEl.textContent = '(' + off + '% off)';
        offEl.hidden = false;
      } else {
        mrpWrap.hidden = true;
        offEl.hidden = true;
      }

      modal.querySelector('[data-md9-qa-feedback]').hidden = true;
    }

    function updateCartBadge() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cartBtn = section.querySelector('.md9-stickybar__btn--cart');
          if (!cartBtn) return;
          if (cart.item_count > 0) {
            cartBtn.classList.add('md9-stickybar__btn--has-items');
            var badge = cartBtn.querySelector('.md9-stickybar__cart-badge');
            if (badge) { badge.textContent = cart.item_count; }
          }
        })
        .catch(function () {});
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-md9-quickadd]');
      if (trigger) {
        e.preventDefault();
        var handle = trigger.getAttribute('data-md9-product-handle');
        if (handle) openModal(handle);
        return;
      }
      if (e.target.closest('[data-md9-qa-close]')) {
        e.preventDefault();
        closeModal();
        return;
      }
      var sizeBtn = e.target.closest('[data-md9-qa-variant]');
      if (sizeBtn && !sizeBtn.disabled) {
        modal.querySelectorAll('.md9-qa-modal__size--on').forEach(function (s) {
          s.classList.remove('md9-qa-modal__size--on');
        });
        sizeBtn.classList.add('md9-qa-modal__size--on');
        currentVariantId = sizeBtn.getAttribute('data-md9-qa-variant');
        modal.querySelector('[data-md9-qa-selected-size]').textContent = sizeBtn.getAttribute('data-md9-qa-size');
        var addBtnReady = modal.querySelector('[data-md9-qa-add]');
        addBtnReady.disabled = false;
        addBtnReady.classList.add('md9-qa-modal__add--ready');
        return;
      }
      if (e.target.closest('[data-md9-qa-add]')) {
        e.preventDefault();
        if (!currentVariantId) return;
        var addBtn = modal.querySelector('[data-md9-qa-add]');
        var addBtnText = addBtn.querySelector('.md9-qa-modal__add-text');
        var feedback = modal.querySelector('[data-md9-qa-feedback]');
        addBtn.disabled = true;
        addBtn.classList.remove('md9-qa-modal__add--ready');
        if (addBtnText) addBtnText.textContent = 'Adding…';
        feedback.classList.remove('md9-qa-modal__feedback--error');
        feedback.hidden = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: currentVariantId, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            if (addBtnText) addBtnText.textContent = '✓ Added';
            addBtn.classList.add('md9-qa-modal__add--success');
            feedback.textContent = 'Added to your cart.';
            feedback.hidden = false;
            updateCartBadge();
            setTimeout(closeModal, 1100);
          })
          .catch(function (err) {
            if (addBtnText) addBtnText.textContent = 'Try again';
            addBtn.disabled = false;
            feedback.textContent = (err && err.description) || 'Could not add. Please try again.';
            feedback.classList.add('md9-qa-modal__feedback--error');
            feedback.hidden = false;
          });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  })();

  var refreshTimer = null;
  var inFlightController = null;

  function buildParams(form) {
    var params = new URLSearchParams();
    var inputs = form.querySelectorAll('input[name], select[name]');
    inputs.forEach(function (el) {
      if (!el.name) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.disabled) return;
      var val = el.value;
      if (val === '' || val == null) return;
      params.append(el.name, val);
    });

    form.querySelectorAll('input[data-md9-size-group]:checked').forEach(function (grp) {
      var codesAttr = grp.getAttribute('data-md9-size-codes') || '';
      var param = grp.getAttribute('data-md9-size-param');
      if (!param || !codesAttr) return;
      codesAttr.split(',').forEach(function (code) {
        code = code.trim();
        if (code) params.append(param, code);
      });
    });

    return params;
  }

  function showLoading(loading) {
    var loadbar = section.querySelector('[data-md9-loadbar]');
    var results = section.querySelector('[data-md9-results]');
    if (loadbar) loadbar.classList.toggle('md9-loadbar--on', loading);
    if (results) results.classList.toggle('md9-main--loading', loading);
  }

  async function refreshFilters(form) {
    if (inFlightController) inFlightController.abort();
    inFlightController = new AbortController();

    var params = buildParams(form);

    var queryStr = params.toString().replace(/\+/g, '%20');
    
    var cacheBuster = '_=' + Date.now();
    var fetchUrl = collectionUrl + '?' + (queryStr ? queryStr + '&' : '') + 'section_id=' + sectionId + '&' + cacheBuster;
    var pushUrl = collectionUrl + (queryStr ? '?' + queryStr : '');

    showLoading(true);
    try {
      var response = await fetch(fetchUrl, {
        signal: inFlightController.signal,
        headers: { 'Accept': 'text/html' }
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newSection = doc.querySelector('[data-md9-section]');
      if (!newSection) throw new Error('No section in response');

      var oldResults = section.querySelector('[data-md9-results]');
      var newResults = newSection.querySelector('[data-md9-results]');
      if (oldResults && newResults) {
        oldResults.innerHTML = newResults.innerHTML;
      }

      setupLoadMore();

      fetchSecondaryIfNeeded();

      syncQfChips();

      applySizeSortOrder();

      updateStickyBarActiveStates();

      updateDiscountCounts();
      applyDiscountFilter();

      var newCountEl = newSection.querySelector('[data-md9-result-count]');
      var newCountText = newCountEl ? newCountEl.textContent : '';
      section.querySelectorAll('[data-md9-result-count]').forEach(function (el) {
        if (newCountText) el.textContent = newCountText;
      });

      try {
        history.replaceState(null, '', pushUrl);
      } catch (e) {}

    } catch (err) {
      if (err.name !== 'AbortError') {
        console.warn('Live filter refresh failed; falling back to form submit:', err);
        form.submit();
      }
    } finally {
      showLoading(false);
    }
  }

  function scheduleRefresh(form) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshFilters(form); }, 250);
  }

  section.addEventListener('change', function (e) {
    var input = e.target;
    if (!input) return;
    
    var hasName = !!input.name;
    var isSizeGroup = input.hasAttribute && input.hasAttribute('data-md9-size-group');
    if (!hasName && !isSizeGroup) return;
    var form = input.closest('[data-md9-filter-form]');
    if (!form) return;
    scheduleRefresh(form);
  });

  section.querySelectorAll('[data-md9-fallback-apply]').forEach(function (b) {
    b.style.display = 'none';
  });

  section.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-md9-close-drawer-after]');
    if (!btn) return;
    e.preventDefault();
    var dr = section.querySelector('[data-md9-drawer]');
    if (dr) {
      dr.hidden = true;
      document.body.style.overflow = '';
    }
  });

  var drawer = section.querySelector('[data-md9-drawer]');
  section.querySelectorAll('[data-md9-open-drawer]').forEach(function (b) {
    b.addEventListener('click', function () {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });
  drawer && drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-md9-close]')) {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }
    var tab = e.target.closest('[data-md9-tab]');
    if (tab) {
      var target = tab.getAttribute('data-md9-tab');
      drawer.querySelectorAll('[data-md9-tab]').forEach(function (t) {
        t.classList.toggle('md9-tab--on', t.getAttribute('data-md9-tab') === target);
      });
      drawer.querySelectorAll('[data-md9-panel]').forEach(function (p) {
        var on = p.getAttribute('data-md9-panel') === target;
        p.classList.toggle('md9-panel--on', on);
        p.hidden = !on;
      });
    }
  });

  section.addEventListener('click', function (e) {
    var sizetab = e.target.closest('[data-md9-sizetab]');
    if (!sizetab) return;
    var target = sizetab.getAttribute('data-md9-sizetab');
    
    var scope = sizetab.closest('.md9-size-group, .md9-panel');
    if (!scope) scope = section;
    scope.querySelectorAll('[data-md9-sizetab]').forEach(function (t) {
      t.classList.toggle('md9-sizetab--on', t.getAttribute('data-md9-sizetab') === target);
    });
    scope.querySelectorAll('[data-md9-sizetab-pane]').forEach(function (p) {
      p.classList.toggle('md9-sizetab-pane--on', p.getAttribute('data-md9-sizetab-pane') === target);
    });
  });

  var modal = section.querySelector('[data-md9-sizechart]');
  section.addEventListener('click', function (e) {
    if (e.target.closest('[data-md9-open-sizechart]')) {
      e.preventDefault();
      if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-md9-sizechart-close]')) {
      if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
    }
    
    var vt = e.target.closest('[data-md9-vendor]');
    if (vt && modal) {
      var v = vt.getAttribute('data-md9-vendor');
      modal.querySelectorAll('[data-md9-vendor]').forEach(function (b) {
        b.classList.toggle('md9-vendor-tab--on', b.getAttribute('data-md9-vendor') === v);
      });
      modal.querySelectorAll('[data-md9-vendor-pane]').forEach(function (p) {
        var on = p.getAttribute('data-md9-vendor-pane') === v;
        p.classList.toggle('md9-modal__vendor--on', on);
        p.hidden = !on;
      });
    }
  });

  var sheet = section.querySelector('[data-md9-sheet]');
  section.querySelectorAll('[data-md9-open-sort]').forEach(function (b) {
    b.addEventListener('click', function () {
      sheet.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });
  sheet && sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-md9-sheet-close]')) {
      sheet.hidden = true;
      document.body.style.overflow = '';
    }
  });

  section.querySelectorAll('form').forEach(function (form) {
    form.addEventListener('submit', function () {
      
      form.querySelectorAll('input[data-md9-injected-unisex]').forEach(function (el) { el.remove(); });
      form.querySelectorAll('input[data-md9-injected-size]').forEach(function (el) { el.remove(); });

      form.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        if ((r.name || '').indexOf('price.lte') !== -1 && r.value === '') {
          r.disabled = true;
          setTimeout(function () { r.disabled = false; }, 100);
        }
      });

      form.querySelectorAll('input[data-md9-size-group]:checked').forEach(function (grp) {
        var paramName = grp.getAttribute('data-md9-size-param');
        var codes = (grp.getAttribute('data-md9-size-codes') || '').split(',');
        codes.forEach(function (code) {
          code = code.trim();
          if (!code) return;
          var h = document.createElement('input');
          h.type = 'hidden';
          h.name = paramName;
          h.value = code;
          h.setAttribute('data-md9-injected-size', '1');
          form.appendChild(h);
        });
      });

      var genderInputs = form.querySelectorAll('[data-md9-gender-input]:checked');
      if (genderInputs.length === 0) return;
      var hasMenOrWomen = false;
      var paramName = '';
      genderInputs.forEach(function (i) {
        var vlow = (i.value || '').toLowerCase();
        var llow = ((i.parentElement && i.parentElement.textContent) || '').toLowerCase();
        
        var isMale = vlow === 'male' || llow.indexOf('men') !== -1 && llow.indexOf('women') === -1;
        var isFemale = vlow === 'female' || llow.indexOf('women') !== -1;
        if (isMale || isFemale) {
          hasMenOrWomen = true;
          paramName = i.name;
        }
      });
      if (!hasMenOrWomen) return;
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = paramName;
      inp.value = 'unisex';
      inp.setAttribute('data-md9-injected-unisex', 'true');
      form.appendChild(inp);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) { drawer.hidden = true; document.body.style.overflow = ''; }
    if (sheet && !sheet.hidden) { sheet.hidden = true; document.body.style.overflow = ''; }
    if (modal && !modal.hidden) { modal.hidden = true; document.body.style.overflow = ''; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-cart"]) return;
  try {
    
(function () {
  // Cross-sell recommendations
  function money(c){ return 'Rs. ' + (c/100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s){ return (s||'').replace(/[&<>"]/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch];}); }
  var xs = document.querySelector('[data-md-xsell]');
  var row = xs && xs.querySelector('[data-md-xsell-row]');
  var pid = xs && xs.getAttribute('data-pid');
  if (row && pid) {
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (!d || !d.products || !d.products.length) { if (xs) xs.style.display = 'none'; return; }
        row.innerHTML = d.products.map(function(p){
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
          var mrp = (p.compare_at_price && p.compare_at_price > p.price) ? '<span class="md-xsell__mrp">' + money(p.compare_at_price) + '</span>' : '';
          return '<a class="md-xsell__card" href="' + esc(p.url) + '">' +
            '<div class="md-xsell__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="md-xsell__title">' + esc(p.title) + '</div>' +
            '<div class="md-xsell__price">' + money(p.price) + mrp + '</div></a>';
        }).join('');
      })
      .catch(function(){ if (xs) xs.style.display = 'none'; });
  }
})();

/* Cart quantity behaviour: make "−" work at qty 1 (remove) and cap "+" to stock */
(function () {
  var cart = document.querySelector('.md-cart');
  if (!cart) return;

  function stock() {
    try {
      var el = document.querySelector('[data-md-stock]');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) { return {}; }
  }
  function maxFor(key) {
    var s = stock();
    return (key in s) ? s[key] : -1; // -1 = unlimited
  }

  var msgEl, msgTimer;
  function showMsg(text) {
    if (!msgEl) {
      msgEl = document.createElement('div');
      msgEl.className = 'md-cart__msg';
      document.body.appendChild(msgEl);
    }
    msgEl.textContent = text;
    msgEl.classList.add('is-show');
    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () { msgEl.classList.remove('is-show'); }, 2600);
  }
  function stockMsg(max) {
    return max <= 0 ? 'This item is out of stock' : 'Only ' + max + ' in stock';
  }

  // 1) "−" at qty 1 → remove the whole line.
  //    Runs in the CAPTURE phase and reads the real current quantity, so it
  //    fires before the theme decrements and never removes on a 2→1 step.
  cart.addEventListener('click', function (e) {
    var w = e.target.closest('[data-button-wrapper-minus]');
    if (!w) return;
    var rowEl = w.closest('[data-cartitem-key]');
    if (!rowEl) return;
    var input = rowEl.querySelector('[data-quantity-input]');
    var cur = input ? (parseInt(input.value, 10) || 1) : 1;
    if (cur > 1) return; // qty 2+ : let the theme decrement normally
    // qty is 1 → remove it
    e.preventDefault();
    e.stopPropagation();
    var removeBtn = rowEl.querySelector('[data-cartitem-remove]');
    if (removeBtn) { removeBtn.click(); return; }
    // Fallback if the remove control is missing: set quantity to 0
    var key = rowEl.getAttribute('data-cartitem-key');
    if (!key) return;
    var url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url) || '/cart/change';
    fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }, true);

  // 2) "+" beyond stock → block before the theme increments + show message
  cart.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-quantity-plus]');
    if (!plus) return;
    var rowEl = plus.closest('[data-cartitem-key]');
    if (!rowEl) return;
    var max = maxFor(rowEl.getAttribute('data-cartitem-key'));
    if (max < 0) return; // unlimited
    var input = rowEl.querySelector('[data-quantity-input]');
    var cur = input ? (parseInt(input.value, 10) || 1) : 1;
    if (cur >= max) {
      e.stopPropagation();
      e.preventDefault();
      showMsg(stockMsg(max));
    }
  }, true);

  // 3) Typing a number above stock → clamp + message (capture, before theme reads it)
  cart.addEventListener('change', function (e) {
    var input = e.target.closest('[data-quantity-input]');
    if (!input) return;
    var rowEl = input.closest('[data-cartitem-key]');
    if (!rowEl) return;
    var max = maxFor(rowEl.getAttribute('data-cartitem-key'));
    if (max < 0) return;
    var val = parseInt(input.value, 10) || 1;
    if (val > max) {
      input.value = max < 1 ? 1 : max;
      showMsg(stockMsg(max));
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
